/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ProductCatalog_ClubRebates_DTO_CustomerClubRebates } from '../models/Gsoa_ProductCatalog_ClubRebates_DTO_CustomerClubRebates';
import type { Gsoa_ProductCatalog_ProductDetail } from '../models/Gsoa_ProductCatalog_ProductDetail';
import type { Gsoa_ProductCatalog_Products } from '../models/Gsoa_ProductCatalog_Products';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaProductCatalogService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaProductCatalogIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Získat značky produktů
     * @returns Gsoa_ProductCatalog_ClubRebates_DTO_CustomerClubRebates OK
     * @throws ApiError
     */
    public static customerClubRebatesWithProducts({
        houseNumber,
        customerClubLevel,
        apiVersion = 1,
        page,
        pageSize = 50,
    }: {
        houseNumber: number,
        customerClubLevel: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_ClubRebates_DTO_CustomerClubRebates> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/houses/{houseNumber}/customerClubRebatesWithProducts',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'customerClubLevel': customerClubLevel,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Kolekce produktů Mimi klubu
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static getMimiClubProductsCatalog({
        houseNumber,
        apiVersion = 1,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filter,
        page,
        pageSize = 50,
    }: {
        houseNumber: number,
        apiVersion?: number,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filter?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/houses/{houseNumber}/mimiClubProductsCatalog',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter': filter,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Kolekce produktů
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static getHouseProducts({
        houseNumber,
        apiVersion = 1,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filter,
        page,
        pageSize = 50,
    }: {
        houseNumber: number,
        apiVersion?: number,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filter?: string,
        /**
         * Page order number (starts at 0). The start offset (page * pageSize) must not exceed 10000.
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/houses/{houseNumber}/products',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter': filter,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Kolekce produktů filtered
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static getHouseProductsFiltered({
        houseNumber,
        apiVersion = 1,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filter,
        page,
        pageSize = 50,
    }: {
        houseNumber: number,
        apiVersion?: number,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filter?: string,
        /**
         * Page order number (starts at 0). The start offset (page * pageSize) must not exceed 10000.
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/houses/{houseNumber}/filteredProducts',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter': filter,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Detail produktu podle VANRu
     * @returns Gsoa_ProductCatalog_ProductDetail OK
     * @throws ApiError
     */
    public static getHouseProductByVanr({
        houseNumber,
        productId,
        apiVersion = 1,
        useRebatesVersion,
    }: {
        houseNumber: number,
        productId: string,
        apiVersion?: number,
        useRebatesVersion?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_ProductDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/houses/{houseNumber}/products/{productId}',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
                'productId': productId,
            },
            query: {
                'useRebatesVersion': useRebatesVersion,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Detail produktu podle EANu
     * @returns Gsoa_ProductCatalog_ProductDetail OK
     * @throws ApiError
     */
    public static getHouseProductByEan({
        houseNumber,
        productId,
        apiVersion = 1,
        useRebatesVersion,
    }: {
        houseNumber: number,
        productId: string,
        apiVersion?: number,
        useRebatesVersion?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_ProductDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/productCatalog/houses/{houseNumber}/products/ean-{productId}',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
                'productId': productId,
            },
            query: {
                'useRebatesVersion': useRebatesVersion,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
